/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Member_TitleInputs */

const en_newsletter_member_title = /** @type {(inputs: Newsletter_Member_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up for the newsletter`)
};

/**
* | output |
* | --- |
* | "Sign up for the newsletter" |
*
* @param {Newsletter_Member_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_member_title = /** @type {((inputs?: Newsletter_Member_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Member_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_member_title(inputs)
});